import { AgencyConstants } from 'features/Agency/agencyHelper';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

useAppConfig.propTypes = {};

function useAppConfig(props) {
  const config = useSelector((state) => state.app.appConfig?.config);
  // link dieu khoan
  const termsUrl =
    _.find(config, (item) => item.key === 'termsUrl')?.value ??
    'https://cms.evgroup.com.vn/dieu-khoan-va-chinh-sach/';

  // ty le hoa hong ban nhuong quyen
  const commissionRateSale =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_SALE)?.value ??
    0;
  // ty le hoa hong ban goi dau tu HTKD
  const commissionRateGroup =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_GROUP)?.value ??
    0;
  // hoa hong gioi thieu mat bang
  const commissionRateLandlord = _.find(
    config,
    (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_LANDLORD
  )?.value;
  // ty le hoa hong ban tru sac
  const commissionRateChargePoint =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_CHARGEPOINT)?.value ??
    0;
  // danh sach dich vu va ty le hoa hong affiliate
  const affiliateCommissionServices =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.AFFILIATE_COMMISSION_SERVICES)?.value;

  // agencyId mac dinh
  const groupAgencyId = Number(_.find(config, (item) => item.key === 'groupAgencyId')?.value);

  // chu ky so cua admin
  const adminAgreementUUID = _.find(config, (item) => item.key === 'adminAgreementUUID')?.value;
  const adminPasscode = _.find(config, (item) => item.key === 'adminPasscode')?.value;

  // chi phi mat bang mac dinh
  const defaultLandlordMonthlyRent = Number(_.find(config, (item) => item.key === 'defaultLandlordMonthlyRent')?.value);
  const defaultLandlordSlotRent = Number(_.find(config, (item) => item.key === 'defaultLandlordSlotRent')?.value);
  const showShareRatio = Number(_.find(config, (item) => item.key === 'showShareRatio')?.value);
  // VAT bán hàng (cấu hình tại Cài đặt chung). Mặc định 8%, giá đã gồm VAT.
  const rawVatRate = _.find(config, (item) => item.key === 'productVatRate')?.value;
  const parsedVatRate = rawVatRate == null || String(rawVatRate).trim() === '' ? NaN : Number(String(rawVatRate).replace(',', '.'));
  const productVatPercent = Number.isFinite(parsedVatRate) && parsedVatRate >= 0 && parsedVatRate <= 100 ? parsedVatRate : 8;
  // Mặc định giá niêm yết CHƯA gồm VAT (VAT cộng thêm khi thanh toán); chỉ khi admin bật thì giá mới "đã gồm VAT".
  const productPricesIncludeVat = ['1', 'true'].includes(
    String(_.find(config, (item) => item.key === 'productPricesIncludeVat')?.value ?? '').trim().toLowerCase()
  );

  return useMemo(() => {
    return {
      termsUrl,

      commissionRateSale,
      commissionRateGroup,
      commissionRateLandlord,
      commissionRateChargePoint,
      affiliateCommissionServices,

      groupAgencyId,
      defaultLandlordMonthlyRent,
      defaultLandlordSlotRent,
      showShareRatio,
      productVatPercent,
      // Tên khóa trùng Config.key để hộp thoại sửa (DialogEditSettingView) tự điền giá trị hiện tại.
      productVatRate: productVatPercent,
      productPricesIncludeVat: productPricesIncludeVat ? 1 : 0,
      productVatExclusive: productPricesIncludeVat ? 0 : 1,

      adminAgreementUUID,
      adminPasscode,

    };
  }, [config]);
}

export default useAppConfig;
